import Typography from '@mui/material/Typography';

import IconCardStyle from './style';

type IconCardProps = {
  icon: string;
  alt: string;
  name: string;
  content: string;
};

const IconCard = ({ icon, alt, name, content }: IconCardProps) => (
  <IconCardStyle>
    <div className="icon-card">
      <img src={`/static/icons/${icon}`} alt={alt} />
      <Typography className="title">{name}</Typography>
      <Typography className="content">{content}</Typography>
    </div>
  </IconCardStyle>
);

export default IconCard;
